type SpacingValue = 16 | 12 | 8 | 6 | 4 | 2 | 1;

const spacingToClass: Record<SpacingValue, string> = {
  16: 'h-16',
  12: 'h-12',
  8: 'h-8',
  6: 'h-6',
  4: 'h-4',
  2: 'h-2',
  1: 'h-1',
};

export const Spacer: React.FC<{
  spacing: SpacingValue;
}> = ({ spacing }) => <div className={spacingToClass[spacing]} />;
